export default {
    account:'账号设定',
    mainAccount: '主账号',
    organizationOfAccountDetails: '企业账号详细信息',
    billingProfile: '账单账户',
    fullDetailsOfAccountProfile: '帐户完整资料详细信息',
    idNumber: '企业代码',
    website: '网址',
    business: '企业',
    fullAddressDetailsOfAccountInformation: '账户信息的完整地址详情',

    updateProfile: '更新账号',
};